
<template>
    <div>
        <div class="mobile-nav d-lg-none">

        </div>

        <h1>{{ $t('pages.onboarding-profession.title') }}</h1>
        <p class="mb-32 text-gray">{{ $t('pages.onboarding-profession.sub_title') }}</p>

        <el-form @submit="submit" class="pb-32">

            <template slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="row">
                    <div v-for="(type, index) in professionTypes.filter((pt) => pt.name !== 'profession_type.unemployed')" :key="index" class="col-12 col-lg-4 mb-32">
                        <div class="h-100 border rounded hover-border-primary p-16 p-xl-32 d-flex mb-16 align-items-center c-pointer text-center d-flex flex-column justify-content-center" :class="{ 'bolding border-primary' : selected_profession === type }" @click.prevent="() => { selected_profession = type; data.profession_type_id = type.id }">
                            <i-sun v-if="type.name === 'profession_type.dayshift'" class="fill-primary i-32 mb-32" data-tc-profession-type-dayshift></i-sun>
                            <i-repeat v-if="type.name === 'profession_type.unregular'" class="fill-primary i-32 mb-32" data-tc-profession-type-unregular></i-repeat>
                            <i-user v-if="type.name === 'profession_type.unemployed'" class="fill-primary i-32 mb-32" data-tc-profession-type-unemployed></i-user>
                            <div class="d-flex flex-column w-100">
                                <span class="w-100 title" v-html="$t(`${type.name}`)"></span>
                                <span class="small text-primary-dark fw-n">{{ $t(`${type.name}_subline`)}}</span>
                                <span class="small mt-16" v-if="type.name === 'profession_type.dayshift' || type.name === 'profession_type.unemployed'">
                                    <i-check class="i-14 bg-gold rounded-circle mr-8 my-auto" style="padding: 2px;"></i-check>
                                    {{ $t(`profession_type.schedule`)}}
                                </span>
                                <span class="small mt-16" v-if="type.name === 'profession_type.unregular'">
                                    <i-check class="i-14 bg-gold rounded-circle mr-8 my-auto" style="padding: 2px;"></i-check>
                                    {{ $t(`profession_type.no_schedule`)}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12 col-xl-5" v-if="selected_profession && !selected_profession.profession_reason">
                        <el-input v-model="data.profession" type="text" rule="required" :name="$t('form-elements.profession')" :label="$t('form-elements.profession')" :placeholder="$t('form-elements.profession_placeholder')" data-tc-profession></el-input>
                    </div>
                    <div class="col-12 col-xl-5" v-if="selected_profession && selected_profession.profession_reason">
                        <el-input v-model="data.reason" type="text" rule="required" :name="$t('form-elements.unemployment_reason')" :label="$t('form-elements.unemployment_reason')" :placeholder="$t('form-elements.unemployment_reason_placeholder')" data-tc-reason></el-input>
                    </div>
                </div>

                <div v-if="knowUsSources.length > 0" class="form-row">
                    <el-select v-model="know_us_source" @input="data.know_us_source_id = know_us_source.id; $nextTick(() => $validator.validate($t('form-elements.how_do_you_know_us')))" rule="required" :translate="true" direction="top" class="col-12 col-lg-5" labelKey="name" valueKey="id" :options="knowUsSources" :name="$t('form-elements.how_do_you_know_us')" :label="$t('form-elements.how_do_you_know_us')" :placeholder="$t('form-elements.how_do_you_know_us_placeholder')" data-tc-know-us-source></el-select>
                </div>
            </template>

            <template slot="footer">
                <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex ml-auto" v-bind:class="{ disabled : loading || !data.profession_type_id }" data-tc-submit>
                    {{ $t('general.next') }}
                    <template v-if="loading">
                        <i-loader class="ml-2 i-20 my-auto"></i-loader>
                    </template>
                    <template v-if="success">
                        <i-check class="ml-2 i-20 my-auto"></i-check>
                    </template>
                </button>
            </template>

        </el-form>

    </div>
</template>

<script>
import { ElInput, ElForm, ElError, ElSelect } from '@/components/forms'

export default {
    name: 'page-onboarding-profession',

    components: { ElInput, ElForm, ElError, ElSelect },

    data: () => ({
        loading: false,
        success: false,
        server_error: null,

        selected_profession: null,
        update: false,
        know_us_source: '',
        data: {
            profession_type_id: null,
            know_us_source_id: null,
            profession: null,
            reason: null
        }
    }),
    created() {
        this.$store.dispatch('general/professionTypes')
        this.$store.dispatch('general/knowUsSources')
    },

    mounted() {
        if (this.currentUser.user && this.currentUser.user.profession_id)
            this.$store.dispatch('user/readProfession', { user_id: this.currentUser.user.id, id: this.currentUser.user.profession_id }).then((profession) => {
                this.selected_profession = this.professionTypes.find((p) => p.id === profession.profession_type_id)

                this.know_us_source = this.knowUsSources.find((ku) => ku.id === profession.know_us_source_id)
                this.data.know_us_source_id = profession.know_us_source_id

                this.data.id = profession.id
                this.data.profession_type_id = profession.profession_type_id
                this.data.profession = profession.profession
                this.data.reason = profession.reason
                this.data.how_do_you_know_us = profession.how_do_you_know_us

                this.update = true
                this.$nextTick().then(() => this.$validator.validateAll())
            })
    },

    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    let user_id = this.currentUser.user.id
                    this.$store.dispatch(`user/${!this.update ? 'createProfession' : 'updateProfession'}`, { user_id, data: this.data }).then(
                        () => {
                            this.loading = false
                            this.success = true
                            this.$router.push({ name: 'onboarding-sleepprofile' })
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        }
                    )
                }
            })
        }
    },

    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        professionTypes() {
            return this.$store.getters['general/professionTypes']
        },
        knowUsSources() {
            return this.$store.getters['general/knowUsSources']
        }
    }
}
</script>
